import { cn } from "~/lib/utils";

export default function Logo({ className }: { className?: string }) {
  return (
    <svg
      className={cn("fill-[#2f1e45] w-20", className)}
      version="1.1"
      id="Laag_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 435.3 190.7"
    >
      <polygon points="435.3,0 384.5,0 358.5,65.1 359.2,0 308.5,0 311.2,89.4 279.9,153.1 204.1,153.1 213.5,110 262.4,110 270.1,74.2 221.2,74.2 229.3,37 280.3,37 288.3,0 184.6,0 143.2,190.7 194,190.7 194,190.7 314,190.7 314.5,189.5 347,116.1 347.1,190.7 399.6,190.7 393.8,89.4"></polygon>
      <path d="M11.3,99.4L0.9,147.2c-1.6,6.4-1.2,13,1.1,19.2c2.2,5.7,6.1,10.6,11.2,14c5.6,3.8,11.8,6.6,18.4,8.3c3.4,0.9,6.9,1.6,10.4,2.1l19.8-91.4H11.3z"></path>
      <path d="M112.3,0L70.7,190.7c11.5-1.7,22.6-5.9,32.4-12.1c13.8-8.9,22.4-21,25.7-36.3L159.8,0H112.3z"></path>
    </svg>
  );
}
